import { render, staticRenderFns } from "./HomeFeatures.vue?vue&type=template&id=7064617e&scoped=true"
import script from "./HomeFeatures.vue?vue&type=script&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&lang=js"
import style0 from "./HomeFeatures.vue?vue&type=style&index=0&id=7064617e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064617e",
  null
  
)

export default component.exports